import classnames from 'classnames';
import React from 'react';

const CSS = require('./CarouselButton.module.scss');

export type CarouselButtonProps = {
  children: any;
  onClick: (e: any) => void;
  disabled: boolean;
  className?: string;
  isInverted?: boolean;
};

function CarouselButton({
  children,
  onClick,
  disabled,
  className,
  isInverted,
}: CarouselButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classnames(CSS.Button, {
        [className]: !!className,
        [CSS.InvertedButton]: isInverted,
      })}
    >
      {children}
    </button>
  );
}

export default CarouselButton;
